var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"allPageContent"},[_c('div',{attrs:{"id":"china-map"}}),_c('div',{attrs:{"id":"china-map2"}})])
}]

export { render, staticRenderFns }